/**
 * @generated SignedSource<<1718f2968f2ca4311db75119de944b1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TransportType = "BUS" | "PLANE" | "SHIP";
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlight_package$data = {
  readonly externalFlights: boolean | null;
  readonly transportType: TransportType | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightDetails_package">;
  readonly " $fragmentType": "PackageDateRowFlight_package";
};
export type PackageDateRowFlight_package$key = {
  readonly " $data"?: PackageDateRowFlight_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlight_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlight_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transportType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalFlights",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRowFlightDetails_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "a3dac6ba50fcf48be2f41334eb0199fe";

export default node;
